import { render, staticRenderFns } from "./header.vue?vue&type=template&id=19fb8f71&scoped=true"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"
import style1 from "./header.vue?vue&type=style&index=1&id=19fb8f71&prod&lang=scss&scoped=true"
import style2 from "./header.vue?vue&type=style&index=2&id=19fb8f71&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fb8f71",
  null
  
)

export default component.exports